import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import { NavLink } from 'react-router-dom';

class BasicBackground extends React.Component {

    render() {

        const { classes, children } = this.props;

        return (
            <div>
                <div className={classes.backgroundBody} />
                <div className={classes.header}>
                    <h1 className={classes.heading}>
                        <NavLink to="/">
                            <img data-test="home" className={classes.logo} src="/images/logo-reversed.png" alt="Logo" />
                        </NavLink>
                        <span className={classes.strapline}>Knowledge graph management</span>
                    </h1>
                    <img style={{ position: 'fixed', right: 0, bottom: 0, width: '50%' }} src="/images/bottom.png" alt="" />
                </div>
                <div>
                    {children}
                </div>
            </div>
        );
    }
}

BasicBackground.propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any
};


export default withStyles(styles)(BasicBackground);